var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"search-results-list"},_vm._l((_vm.results),function(item,i){return _c('search-results-item',{key:`${item.id}_${item.type}_${i}`,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }